import { Actions } from './actions';
import { Part } from './part';
import { Dictionary } from 'lodash';
import { VehicleMaintenance } from './vehicleMaintenance';

export class VehicleMaintenanceRequest {
    constructor(vehicleMaintenance: VehicleMaintenance) {
        this.vin = vehicleMaintenance.vin;
        this.parts = vehicleMaintenance.parts;
        this.vehicleScheduleId = vehicleMaintenance.vehicleScheduleId;
        this.vehicleScheduleName = vehicleMaintenance.vehicleScheduleName;
        this.completionDate = vehicleMaintenance.completionDate;
        this.date = vehicleMaintenance.date;
        this.action = vehicleMaintenance.action;
        this.state = vehicleMaintenance.state;
        this.updatedBy = vehicleMaintenance.updatedBy;
        this.createdBy = vehicleMaintenance.createdBy;
        this.notes = vehicleMaintenance.notes;
        this.id = vehicleMaintenance.id;
        this.hours = vehicleMaintenance.hours;
        this.odometer = vehicleMaintenance.vehicleState?.odometer;
        this.engineHours = vehicleMaintenance.vehicleState?.engine?.operationDuration;
    }

    public vin: string;
    public parts: Part[];
    public vehicleScheduleId: string;
    public vehicleScheduleName: string;
    public completionDate: Date;
    public date: Dictionary<Date>;
    public action: Actions;
    public state: Dictionary<string>;
    public updatedBy: string;
    public createdBy: string;
    public notes: string;
    public id: string;
    public hours: number;
    public odometer: number;
    public engineHours: number;
}